export default __webpack_public_path__ + "static/media/layout1.f6a857d7.svg";